import { useSetNotice } from 'hooks/useSetNotice'
import { isLkmDomain } from 'router/utils/hostUtils'
import { Severity } from 'widget/Notifications'

export default function CheckIsApiVariableExist() {
  const setNotice = useSetNotice()
  const env = process.env
  const isLkm = isLkmDomain()
  const apiPath = isLkm ? env.REACT_APP_LKM_API_PATH : env.REACT_APP_API_PATH

  if (env.NODE_ENV === 'production' && !apiPath) {
    setNotice(
      'Ошибка соединения, пожалуйста, попробуйте позднее',
      Severity.error,
    )

    return null
  }

  if (!apiPath) {
    const missingVar = isLkm ? 'REACT_APP_LKM_API_PATH' : 'REACT_APP_API_PATH'
    setNotice(
      `Не удалось найти переменную окружения ${missingVar}. 
      Пожалуйста, укажите базовый URL для API в файле .env`,
      Severity.error,
    )
  }

  return null
}
